import type { NavItem, SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

// Placeholders still to replace: storeLinks, contact.email and the legal block.
export const siteConfig: SiteConfig = {
    name: 'Jeme',
    description: 'Jeme conecta talleres, desguaces y particulares para pedir, ofertar y comprar piezas de coche. Pide recambios con una foto y recibe ofertas de desguaces.',
    url: getOrigin(),
    contact: {
        email: 'contacto@example.com'
    },
    storeLinks: {
        appStore: '#',
        googlePlay: '#'
    },
    legal: {
        owner: '[Nombre o razón social del titular]',
        taxId: '[NIF]',
        address: '[Domicilio]'
    }
}

export const NAV_ITEMS: NavItem[] = [
    { label: 'Cómo funciona', href: '/#como-funciona' },
    { label: 'Demo', href: '/#demo' },
    { label: 'Para quién', href: '/#para-quien' },
    { label: 'Funciones', href: '/#funciones' },
    { label: 'Contacto', href: '/#contacto' }
]

export const LEGAL_LINKS: NavItem[] = [
    { label: 'Aviso legal', href: '/aviso-legal' },
    { label: 'Política de privacidad', href: '/privacidad' },
    { label: 'Política de cookies', href: '/cookies' }
]

export const LEGAL_UPDATED_AT = '21 de octubre de 2026'
